export const LOOM_NUDGE_REMIND_ME = 'twcg-2202-loom-nudge:remindMe';
